import { DOCUMENT, NgClass, ViewportScroller } from '@angular/common';
import { Component, Inject, Input, LOCALE_ID, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { StaticFileHash } from '@scalefast/ecommerce-core';
import { from } from 'rxjs';
import { ContentfulFAQContent } from 'src/app/core/interfaces/Contentful/FAQ/ContentfulFAQContent';
import { ContentfulFAQTopic } from 'src/app/core/interfaces/Contentful/FAQ/ContentfulFAQTopic';
import { ContentfulFAQLandingPageContent } from 'src/app/core/interfaces/Contentful/Page/ContentfulFAQLandingPageContent';
import { ContentfulFaqService } from 'src/app/shared/services/contentful-faq.service';

@Component({
  selector: 'app-contentful-faq-landing',
  templateUrl: './contentful-faq-landing.component.html',
  styleUrls: ['./contentful-faq-landing.component.scss'],
  standalone: true,
  imports: [NgClass, StaticFileHash],
})
export class AppContentfulFAQLandingComponent implements OnInit {
  @Input() FAQLandingContent: ContentfulFAQLandingPageContent | undefined;

  router: Router;
  contentfulFaqService: ContentfulFaqService;
  activeTopic: ContentfulFAQTopic = {
    title: '',
    topicIcon: '',
    topicHoverIcon: '',
    faqs: [],
  };
  activeTopicIndex: number = 0;

  constructor(
    @Inject(DOCUMENT) private _doc: Document,
    @Inject(LOCALE_ID) private locale: string,
    router: Router,
    contentfulFaqService: ContentfulFaqService,
    private viewportScroller: ViewportScroller,
  ) {
    this.router = router;
    this.contentfulFaqService = contentfulFaqService;
  }

  ngOnInit(): void {
    if (this.FAQLandingContent && this.FAQLandingContent.topics.length) {
      // Order topics alpabetically to maintain the same order on page load
      const sortedTopics = this.FAQLandingContent.topics.sort((a, b) => a.title.localeCompare(b.title));
      this.FAQLandingContent.topics = sortedTopics;
      if (typeof sessionStorage !== 'undefined' && sessionStorage !== null) {
        // sessionStorage is available
        const activeFaqSection = Number(sessionStorage.getItem('activeFaqSection'));
        if (activeFaqSection) {
          this.FAQLandingContent.topics[activeFaqSection].isActive = true;
          this.activeTopic = this.FAQLandingContent.topics[activeFaqSection];
          this.activeTopicIndex = activeFaqSection;
        }
      }
      this.FAQLandingContent.topics[this.activeTopicIndex].isActive = true;
      this.activeTopic = this.FAQLandingContent.topics[this.activeTopicIndex];
    }
  }

  topicSelection(clickedTopic: ContentfulFAQTopic): void {
    this.FAQLandingContent?.topics.forEach((topic, i) => {
      topic.isActive = false;

      if (topic === clickedTopic) {
        topic.isActive = true;
        this.activeTopicIndex = i;
      }
      this.scrollToFAQSection('faq-landing__content');
    });

    this.activeTopic = clickedTopic;
  }

  scrollToFAQSection(id: string) {
    const element = document.getElementById(id);
    const hostPosition = this.viewportScroller.getScrollPosition();
    const headerSite = this._doc.getElementById('header__site');
    if (element && headerSite) {
      const elementPosition = element.getBoundingClientRect();
      // Take into account header height in scroll to avoid topic title to hide
      const scrollTop = hostPosition[1] + elementPosition.top - headerSite.offsetHeight;
      this.viewportScroller.scrollToPosition([0, scrollTop]);
    }
  }

  onTopicHover(hoveredTopic: ContentfulFAQTopic): void {
    this.FAQLandingContent?.topics.forEach((topic) => {
      topic.isHovered = false;

      if (topic === hoveredTopic) {
        topic.isHovered = true;
      }
    });
  }

  onTopicLeave(): void {
    this.FAQLandingContent?.topics.forEach((topic) => {
      topic.isHovered = false;
    });
  }

  redirectToFAQ(faqId: string) {
    from(this.contentfulFaqService.getFaqContent(faqId)).subscribe((faqContent: ContentfulFAQContent) => {
      if (faqContent.slug) {
        let slug = faqContent.slug;
        // Remove locale from slug before redirecting
        if (faqContent.slug.includes(this.locale.toLocaleLowerCase())) {
          slug = slug.replace('/' + this.locale.toLocaleLowerCase(), '');
        }
        // Save the active section ID to sessionStorage
        sessionStorage.setItem('activeFaqSection', this.activeTopicIndex.toString());

        this.router.navigate([slug]);
      }
    });
  }
}
